// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  reportableUrl: 'https://reportablesp.corerfid.net/api/lgs/',
  apiUrl: 'https://lgsapi.corerfid.net/api/'
};

//  export const environment = {
//   production: false,
//   reportableUrl: 'http://reportable.dev.corerfid.com/api/lgs/',
//   apiUrl: 'http://coreapi.dev5.corerfid.com/api/'
//   //apiUrl: 'http://lgsapi.test.corerfid.com/api/'
//  };
